import React, { useState } from 'react';
import {
  Button, Col,
  Form,
  Input,
  Row, Select,
  Space, Switch,
  Typography,
} from 'antd';
import { mastercardDesigns, visaDesigns } from '../../../interfaces/card-products';
import { ActiveCenter, FirstStepFormInputs } from './first-step';

type SecondStepProps = {
  goToNext: () => void;
  goToPrevious: () => void;
  firstStepData: FirstStepFormInputs | null;
  secondStepData: SecondStepFormInputs | null;
  setSecondStepData: (data: SecondStepFormInputs) => void;
};
export type SecondStepFormInputs = {
  design: string,
  logo: string,
  commercialBin: boolean,
  recordingCode: number
};

const SecondStep: React.FC<SecondStepProps> = ({
  goToPrevious,
  goToNext,
  firstStepData,
  setSecondStepData,
  secondStepData
}) => {
  
  const [form] = Form.useForm<SecondStepFormInputs>();
  const [commercialBin, setCommercialBin] = useState(false);

  const onSubmit = (data: SecondStepFormInputs) => {
    data.commercialBin = commercialBin;
    setSecondStepData(data);
    goToNext();
  };

  return (
    <>
      <Form<SecondStepFormInputs>
        layout="vertical"
        onFinish={onSubmit}
        initialValues={secondStepData || undefined}
        form={form}
        style={{ minWidth: '420px', maxWidth: '50%', margin: 'auto' }}
      >
        <Typography.Title level={2}>Datos Generales</Typography.Title>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item<SecondStepFormInputs>
              name="design"
              label={'Diseño'}
              rules={[{ required: true, message: 'Por favor, ingresa un diseño.' }]}
            >
              <Select
                placeholder="Seleccionar diseño"
                options={ firstStepData?.brand === 'MASTERCARD' ? mastercardDesigns : visaDesigns }
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<SecondStepFormInputs>
              name="logo"
              label={'Logo'}
              rules={[{max:4, required: false}]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<SecondStepFormInputs>
              name="commercialBin"
              label={'Bin comercial'}
              initialValue={commercialBin}
              rules={[{required: true}]}
            >
              <ActiveCenter>
                <Switch value={commercialBin} onChange={() => setCommercialBin(!commercialBin)} defaultChecked />
              </ActiveCenter>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<SecondStepFormInputs>
              name="recordingCode"
              label={'Codigo de Grabado'}
              rules={[{max: 9999,required: true, message: 'Por favor, ingresa un código valido.' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ textAlign: 'center' }}>
          <Space>
            <Button onClick={goToPrevious}>Anterior</Button>
            <Button htmlType="submit" type="primary">
              Siguiente
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </>
  );
};

export default SecondStep;
